import moment from 'moment';

export function calculateDateRange(timeFrame, dateRange) {
    const endDate = moment();
    
    switch(timeFrame) {
        case 'all':
            return {}; // No date filtering
        case '7d':
            return {
                start: endDate.clone().subtract(7, 'days').format('YYYY-MM-DD'),
                end: endDate.format('YYYY-MM-DD'),
            };
        case '30d':
            return {
                start: endDate.clone().subtract(30, 'days').format('YYYY-MM-DD'),
                end: endDate.format('YYYY-MM-DD'),
            };
        case 'custom':
            return {
                start: dateRange[0].format('YYYY-MM-DD'),
                end: dateRange[1].format('YYYY-MM-DD'),
            }
        default:
            return {
                start: null,
                end: null,
            };
    }
}
